import React, { useState } from "react";
import { Col, Container, Row, Button, Form, Pagination } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import { deleteContent } from "../../../../../redux/states/settings/thunk";
import { toast } from "react-toastify";
import AddContent from "../../../../Common/Modals/AddContent";
import {
  clearSelected,
  editContent,
} from "../../../../../redux/states/settings/slice";
import CustomPagination from "../../../../CustomPagination";

const Contentpage = (props) => {
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const tableData = useSelector((state) => state.settings)?.allContent;
  const {
    filter,
    setFilter,
    getContentList,
    handleNextClick,
    totalPage,
    handlePreviousClick,
  } = props;
  const dispatch = useDispatch();

  const handleDeleteContent = (dta) => {
    const data = {
      contentId: dta?._id,
    };
    dispatch(deleteContent(data))
      .unwrap()
      .then((res) => {
        toast.success(res.message);
        getContentList();
      })
      .catch((err) => {
        toast.error(err.message);
      });
  };

  const handleEditContent = (dta) => {
    setShowUpdateModal(true);
    dispatch(editContent(dta));
  };

  const onHide = () => {
    dispatch(clearSelected());
    setShowUpdateModal(false);
  };

  return (
    <section className="content_pages mt-4">
      <Container fluid>
        <AddContent
          getContentList={getContentList}
          show={showUpdateModal}
          onHide={onHide}
          setShowUpdateModal={setShowUpdateModal}
        />
        <div>
          <Form>
            <div className="TableFilters d-flex align-items-center justify-content-between gap-10 pb-4 flex-wrap">
              <div className="left d-flex align-items-center gap-10 flex-wrap">
                <h2 className="m-0 fw-bold heading ">Content Management</h2>
              </div>
              <div className="right d-flex align-items-center justify-content-end gap-10 flex-wrap btnWrpper">
                <div className="px-2"></div>
              </div>
            </div>
            <div className="FAQ_table CommonTable">
              <div className="table-responsive">
                <table className="table">
                  <thead className="">
                    <tr>
                      {/* <th className="border-0">
                          <FormGroup check>
                            <Label check>
                              <Input type="checkbox" />
                            </Label>
                          </FormGroup>
                        </th> */}
                      <th className="border-0">Title</th>
                      <th className="border-0">Status</th>
                      <th className="border-0">Created At</th>
                      <th className="border-0">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {tableData?.map((data, idx) => {
                      return (
                        <tr key={idx}>
                          {/* <td className="fw-bold">
                              <FormGroup check>
                                <Label check>
                                  <Input type="checkbox" />
                                </Label>
                              </FormGroup>
                            </td> */}
                          <td className="border-0">{data?.name}</td>
                          <td className="border-0">
                            <span className="activestatus">{data?.status}</span>
                          </td>
                          <td className="border-0">
                            {moment(data?.createdAt).format("MM/DD/YYYY")}
                          </td>
                          <td className="border-0">
                            <div className="d-flex align-items-center justify-content-center gap-4">
                              <Button
                                variant="transparent"
                                className="border-0 p-0"
                                onClick={() => handleEditContent(data)}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="19"
                                  height="19"
                                  viewBox="0 0 19 19"
                                  fill="none"
                                >
                                  <g id="edit">
                                    <path
                                      id="Vector"
                                      d="M8.5 1.20947H6.83333C2.66667 1.20947 1 2.87614 1 7.04281V12.0428C1 16.2095 2.66667 17.8761 6.83333 17.8761H11.8333C16 17.8761 17.6667 16.2095 17.6667 12.0428V10.3761"
                                      stroke="black"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                    <path
                                      id="Vector_2"
                                      d="M12.7001 2.05936L6.13339 8.62602C5.88339 8.87602 5.6334 9.36769 5.5834 9.72602L5.22506 12.2344C5.09173 13.1427 5.7334 13.776 6.64173 13.651L9.15006 13.2927C9.50006 13.2427 9.99173 12.9927 10.2501 12.7427L16.8167 6.17602C17.9501 5.04269 18.4834 3.72602 16.8167 2.05936C15.1501 0.392691 13.8334 0.926024 12.7001 2.05936Z"
                                      stroke="black"
                                      stroke-miterlimit="10"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                    <path
                                      id="Vector_3"
                                      d="M11.7583 3.00098C12.3166 4.99264 13.875 6.55098 15.875 7.11764"
                                      stroke="black"
                                      stroke-miterlimit="10"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                  </g>
                                </svg>
                              </Button>
                              {/* <Button
                                variant="transparent"
                                className="border-0 p-0"
                                onClick={() => handleDeleteContent(data)}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="16"
                                  height="17"
                                  viewBox="0 0 16 17"
                                  fill="none"
                                >
                                  <path
                                    d="M7.71062 5.81438e-09C8.4026 -4.53024e-05 9.06838 0.264707 9.57136 0.739946C10.0743 1.21518 10.3764 1.86488 10.4156 2.55576L10.4198 2.70914H14.796C14.9544 2.70918 15.1069 2.76936 15.2227 2.8775C15.3384 2.98563 15.4088 3.13368 15.4196 3.29171C15.4304 3.44974 15.3808 3.60598 15.2808 3.72885C15.1809 3.85173 15.038 3.93208 14.8811 3.95367L14.796 3.95951H14.1325L13.0655 14.8127C13.0121 15.3538 12.768 15.8583 12.377 16.236C11.9859 16.6138 11.4733 16.8403 10.9307 16.875L10.784 16.88H4.63721C4.09326 16.88 3.56705 16.6865 3.15261 16.3342C2.73816 15.982 2.46249 15.4938 2.37487 14.9569L2.3557 14.8119L1.28788 3.95951H0.625185C0.474109 3.9595 0.328146 3.90479 0.214288 3.80549C0.10043 3.70619 0.0263814 3.56902 0.00583504 3.41935L0 3.33432C6.37097e-06 3.18324 0.0547184 3.03728 0.154018 2.92342C0.253318 2.80957 0.390488 2.73552 0.54016 2.71497L0.625185 2.70914H5.00148C5.00148 1.99063 5.28691 1.30155 5.79497 0.793487C6.30303 0.285426 6.99211 5.81438e-09 7.71062 5.81438e-09ZM12.8763 3.95951H2.54409L3.60023 14.6894C3.62362 14.9288 3.72912 15.1527 3.89884 15.3232C4.06856 15.4937 4.29203 15.6002 4.53134 15.6246L4.63721 15.6296H10.784C11.2842 15.6296 11.7085 15.2754 11.8052 14.7944L11.8218 14.6894L12.8755 3.95951H12.8763ZM9.16938 6.25185C9.32046 6.25186 9.46642 6.30657 9.58028 6.40587C9.69414 6.50517 9.76819 6.64234 9.78873 6.79201L9.79457 6.87704V12.7121C9.79452 12.8705 9.73435 13.023 9.62621 13.1387C9.51807 13.2545 9.37003 13.3248 9.212 13.3356C9.05396 13.3464 8.89773 13.2968 8.77485 13.1969C8.65197 13.0969 8.57162 12.954 8.55003 12.7971L8.5442 12.7121V6.87704C8.5442 6.71123 8.61007 6.55221 8.72731 6.43496C8.84456 6.31772 9.00357 6.25185 9.16938 6.25185ZM6.25185 6.25185C6.40293 6.25186 6.54889 6.30657 6.66275 6.40587C6.77661 6.50517 6.85066 6.64234 6.8712 6.79201L6.87704 6.87704V12.7121C6.87699 12.8705 6.81682 13.023 6.70868 13.1387C6.60054 13.2545 6.4525 13.3248 6.29446 13.3356C6.13643 13.3464 5.98019 13.2968 5.85732 13.1969C5.73444 13.0969 5.65409 12.954 5.6325 12.7971L5.62667 12.7121V6.87704C5.62667 6.71123 5.69253 6.55221 5.80978 6.43496C5.92702 6.31772 6.08604 6.25185 6.25185 6.25185ZM7.71062 1.25037C7.34452 1.25038 6.99181 1.38805 6.7225 1.63605C6.45319 1.88405 6.28698 2.22424 6.25685 2.5891L6.25185 2.70914H9.16938C9.16938 2.32225 9.01569 1.9512 8.74212 1.67763C8.46855 1.40406 8.09751 1.25037 7.71062 1.25037Z"
                                    fill="black"
                                  />
                                </svg>
                              </Button> */}
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
              {/* <div className="d-flex align-items-center justify-content-between gap-10 flex-wrap mt-3">
                <div className="left">
                  <div className="showResult d-flex align-items-center gap-10">
                    <label htmlFor="" className="form-label m-0">
                      Show Result:
                    </label>
                    <Form.Select
                      aria-label="Default select example"
                      value={filter.limit}
                      onChange={(e) => setFilter({ limit: e.target.value })}
                    >
                      {[10, 20, 30, 50]?.map((itm) => (
                        <option value={itm}>{itm}</option>
                      ))}
                    </Form.Select>
                  </div>
                </div>
                <div className="right ">
                  <Pagination>
                    <Pagination.Prev onClick={handlePreviousClick} />
                    {Array.from(Array(totalPage).keys())?.map((page, index) => {
                      var pageNo = page + 1;
                      return (
                        <Pagination.Item
                          active={pageNo == filter.page}
                          onClick={() => setFilter({ page: pageNo })}
                        >
                          {pageNo}
                        </Pagination.Item>
                      );
                    })}

                    <Pagination.Next onClick={handleNextClick} />
                  </Pagination>
                </div>
              </div> */}

              <CustomPagination
                totalPage={totalPage}
                setFilter={setFilter}
                filter={filter}
              />
            </div>
          </Form>
        </div>
      </Container>
    </section>
  );
};

export default Contentpage;
